import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('PATIENTS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class PatientsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'patients' como el nombre del recurso a la clase base
    super('patients');
    log.debug('Servicio de Pacientes inicializado');
  }

}
